var _rect, _rect2, _rect3, _rect4, _g, _mask, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _mask2, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _mask3, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 375,
    height: 264,
    viewBox: "0 0 375 264",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 375,
    height: 264,
    fill: "#F5F5F5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -159,
    y: -995,
    width: 1746,
    height: 1948,
    rx: 35,
    stroke: "#C3A63E",
    strokeWidth: 10
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 375,
    height: 895,
    transform: "translate(0 -254)",
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 375,
    height: 801.049,
    transform: "translate(0 -160)",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14_178890)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 375,
    height: 264,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_14_178890)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 138.181,
    cy: 79.8676,
    rx: 42.6676,
    ry: 42.6676,
    fill: "#FFAF4B"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_14_178890)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 211.86,
    cy: 79.8676,
    rx: 42.6676,
    ry: 42.6676,
    fill: "#E99ABB"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_14_178890)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 140.748,
    cy: 129,
    rx: 42.6676,
    ry: 42.6676,
    fill: "#4BBC91"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_14_178890)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 188.156,
    cy: 129,
    rx: 42.6676,
    ry: 42.6676,
    fill: "#FFE051"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_f_14_178890)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 235.565,
    cy: 129,
    rx: 42.6676,
    ry: 42.6676,
    fill: "#FEB087"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_f_14_178890)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 164.452,
    cy: 178.132,
    rx: 42.6676,
    ry: 42.6676,
    fill: "#E1BFF7"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_f_14_178890)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 211.86,
    cy: 178.132,
    rx: 42.6676,
    ry: 42.6676,
    fill: "#FFE051"
  }))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_d_14_178890)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 53.1499,
    y: 88.3,
    width: 267.7,
    height: 135.4,
    rx: 27,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.1499,
    y: 130.25,
    width: 101.7,
    height: 17.1,
    rx: 8.55,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.714 131.441C205.714 132.651 204.731 133.634 203.497 133.634C202.312 133.634 201.304 132.651 201.304 131.441C201.304 130.232 202.312 129.249 203.497 129.249C204.731 129.249 205.714 130.232 205.714 131.441ZM201.783 148.3V135.7H205.235V148.3H201.783ZM217.482 144.47C217.482 146.914 215.39 148.577 212.694 148.577C210.476 148.577 208.586 147.796 207.503 146.158L209.872 144.142C210.426 145.074 211.484 145.604 212.694 145.604C213.4 145.604 214.08 145.326 214.08 144.696C214.08 144.167 213.778 143.865 212.392 143.487L211.459 143.26C209.141 142.655 207.931 141.168 207.982 139.228C208.032 136.91 210.048 135.423 212.719 135.423C214.634 135.423 216.121 136.154 217.079 137.54L214.811 139.379C214.231 138.648 213.5 138.27 212.669 138.27C212.064 138.27 211.409 138.548 211.409 139.127C211.409 139.505 211.585 139.934 212.644 140.211L213.828 140.564C216.096 141.168 217.482 142.277 217.482 144.47ZM237.828 147.317C237.828 151.878 234.905 153.819 231.049 153.819C228.882 153.819 226.614 153.164 225.178 151.803L227.068 149.232C228.176 150.291 229.613 150.795 230.999 150.795C233.04 150.795 234.376 149.358 234.376 147.342V146.486C233.72 147.418 232.334 148.149 230.722 148.149C227.446 148.149 224.774 145.326 224.774 141.798C224.774 138.245 227.446 135.423 230.722 135.423C232.334 135.423 233.72 136.154 234.376 137.111V135.7H237.828V147.317ZM228.252 141.798C228.252 143.714 229.714 145.024 231.452 145.024C233.191 145.024 234.653 143.714 234.653 141.798C234.653 139.858 233.191 138.573 231.452 138.573C229.714 138.573 228.252 139.858 228.252 141.798ZM253.468 142C253.468 145.679 250.494 148.577 246.84 148.577C243.186 148.577 240.212 145.679 240.212 142C240.212 138.321 243.186 135.423 246.84 135.423C250.494 135.423 253.468 138.321 253.468 142ZM243.69 142C243.69 143.94 245.026 145.352 246.84 145.352C248.654 145.352 249.965 143.94 249.965 142C249.965 140.06 248.654 138.648 246.84 138.648C245.026 138.648 243.69 140.06 243.69 142ZM268.291 142C268.291 145.679 265.317 148.577 261.663 148.577C258.009 148.577 255.036 145.679 255.036 142C255.036 138.321 258.009 135.423 261.663 135.423C265.317 135.423 268.291 138.321 268.291 142ZM258.513 142C258.513 143.94 259.849 145.352 261.663 145.352C263.478 145.352 264.788 143.94 264.788 142C264.788 140.06 263.478 138.648 261.663 138.648C259.849 138.648 258.513 140.06 258.513 142ZM269.884 142C269.884 138.422 272.455 135.423 275.806 135.423C277.545 135.423 278.881 136.305 279.435 137.111V129.4H282.887V148.3H279.435V146.889C278.881 147.695 277.545 148.577 275.806 148.577C272.455 148.577 269.884 145.578 269.884 142ZM279.712 142C279.712 140.034 278.427 138.573 276.537 138.573C274.647 138.573 273.362 140.034 273.362 142C273.362 143.966 274.647 145.427 276.537 145.427C278.427 145.427 279.712 143.966 279.712 142Z",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.953 182.7L107.584 175.518L105.24 182.7H101.813L97.6298 170.1H101.309L103.703 178.164L106.248 170.1H108.894L111.465 178.164L113.833 170.1H117.538L113.38 182.7H109.953ZM123.163 165.841C123.163 167.051 122.18 168.034 120.946 168.034C119.761 168.034 118.753 167.051 118.753 165.841C118.753 164.632 119.761 163.649 120.946 163.649C122.18 163.649 123.163 164.632 123.163 165.841ZM119.232 182.7V170.1H122.684V182.7H119.232ZM134.2 182.574C133.646 182.75 132.966 182.851 132.008 182.851C129.337 182.851 127.195 181.364 127.195 178.29V173.124H124.65V170.1H127.195V166.597H130.647V170.1H134.2V173.124H130.647V177.61C130.647 179.147 131.302 179.752 132.789 179.752C133.344 179.752 133.797 179.676 134.2 179.525V182.574ZM136.574 182.7V163.8H140.026V171.536C140.682 170.528 141.992 169.823 143.63 169.823C146.679 169.823 148.494 172.04 148.494 175.316V182.7H145.041V175.896C145.041 174.082 144.26 172.973 142.824 172.973C141.236 172.973 140.026 174.132 140.026 176.551V182.7H136.574Z",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 155.65,
    y: 164.65,
    width: 101.7,
    height: 17.1,
    rx: 8.55,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.399 176.224V175.745C267.399 174.258 268.281 173.275 269.592 172.368C270.751 171.562 271.835 171.083 271.835 169.823C271.835 168.638 270.902 167.908 269.743 167.908C268.508 167.908 267.374 168.714 267.374 170.176H263.922C263.922 167.051 266.467 164.506 269.743 164.506C273.019 164.506 275.287 166.95 275.287 169.621C275.287 171.486 274.657 172.796 273.019 174.031C271.759 174.964 270.852 175.468 270.852 176.148V176.224H267.399ZM271.633 180.382C271.633 181.768 270.524 182.902 269.113 182.902C267.727 182.902 266.593 181.768 266.593 180.382C266.593 178.996 267.727 177.862 269.113 177.862C270.524 177.862 271.633 178.996 271.633 180.382Z",
    fill: "#212121"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 44.5,
    y: 41,
    width: 285,
    height: 166,
    rx: 30,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.469 94L161.433 93.146C160.579 93.79 159.515 94.168 158.353 94.168C155.511 94.168 153.215 91.872 153.215 89.03C153.215 86.188 155.511 83.892 158.353 83.892C161.195 83.892 163.491 86.188 163.491 89.03C163.491 90.052 163.197 91.004 162.679 91.802L165.325 94H162.469ZM155.259 89.03C155.259 90.766 156.617 92.208 158.353 92.208C158.899 92.208 159.403 92.068 159.851 91.816L158.381 90.598L159.543 89.198L161.097 90.486C161.321 90.052 161.447 89.548 161.447 89.03C161.447 87.294 160.089 85.852 158.353 85.852C156.617 85.852 155.259 87.294 155.259 89.03ZM165.19 91.06V87H167.108V90.738C167.108 91.788 167.472 92.404 168.298 92.404C169.152 92.404 169.74 91.774 169.74 90.416V87H171.658V94H169.74V93.202C169.376 93.762 168.718 94.154 167.822 94.154C166.128 94.154 165.19 92.922 165.19 91.06ZM173.006 90.5C173.006 88.428 174.56 86.846 176.688 86.846C178.522 86.846 180.132 88.022 180.132 90.29C180.132 90.458 180.132 90.654 180.104 90.948H174.868C174.98 91.886 175.806 92.404 176.73 92.404C177.598 92.404 178.228 91.998 178.536 91.522L179.964 92.586C179.32 93.524 178.186 94.154 176.716 94.154C174.63 94.154 173.006 92.712 173.006 90.5ZM176.632 88.428C175.918 88.428 175.12 88.792 174.938 89.646H178.214C178.046 88.82 177.346 88.428 176.632 88.428ZM186.51 91.872C186.51 93.23 185.348 94.154 183.85 94.154C182.618 94.154 181.568 93.72 180.966 92.81L182.282 91.69C182.59 92.208 183.178 92.502 183.85 92.502C184.242 92.502 184.62 92.348 184.62 91.998C184.62 91.704 184.452 91.536 183.682 91.326L183.164 91.2C181.876 90.864 181.204 90.038 181.232 88.96C181.26 87.672 182.38 86.846 183.864 86.846C184.928 86.846 185.754 87.252 186.286 88.022L185.026 89.044C184.704 88.638 184.298 88.428 183.836 88.428C183.5 88.428 183.136 88.582 183.136 88.904C183.136 89.114 183.234 89.352 183.822 89.506L184.48 89.702C185.74 90.038 186.51 90.654 186.51 91.872ZM192.343 93.93C192.035 94.028 191.657 94.084 191.125 94.084C189.641 94.084 188.451 93.258 188.451 91.55V88.68H187.037V87H188.451V85.054H190.369V87H192.343V88.68H190.369V91.172C190.369 92.026 190.733 92.362 191.559 92.362C191.867 92.362 192.119 92.32 192.343 92.236V93.93ZM195.846 84.634C195.846 85.306 195.3 85.852 194.614 85.852C193.956 85.852 193.396 85.306 193.396 84.634C193.396 83.962 193.956 83.416 194.614 83.416C195.3 83.416 195.846 83.962 195.846 84.634ZM193.662 94V87H195.58V94H193.662ZM204.273 90.5C204.273 92.544 202.621 94.154 200.591 94.154C198.561 94.154 196.909 92.544 196.909 90.5C196.909 88.456 198.561 86.846 200.591 86.846C202.621 86.846 204.273 88.456 204.273 90.5ZM198.841 90.5C198.841 91.578 199.583 92.362 200.591 92.362C201.599 92.362 202.327 91.578 202.327 90.5C202.327 89.422 201.599 88.638 200.591 88.638C199.583 88.638 198.841 89.422 198.841 90.5ZM205.607 94V87H207.525V87.798C207.889 87.238 208.617 86.846 209.527 86.846C211.221 86.846 212.229 88.078 212.229 89.898V94H210.311V90.22C210.311 89.212 209.877 88.596 209.079 88.596C208.197 88.596 207.525 89.24 207.525 90.584V94H205.607ZM218.277 94V85.95H216.177L217.577 84.06H220.195V94H218.277Z",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.72 127V110.67H110.055V127H106.72ZM121.293 123.504C121.293 125.735 119.384 127.253 116.923 127.253C114.899 127.253 113.174 126.54 112.185 125.045L114.347 123.205C114.853 124.056 115.819 124.539 116.923 124.539C117.567 124.539 118.188 124.286 118.188 123.711C118.188 123.228 117.912 122.952 116.647 122.607L115.796 122.4C113.68 121.848 112.576 120.491 112.622 118.72C112.668 116.604 114.508 115.247 116.946 115.247C118.694 115.247 120.051 115.914 120.925 117.179L118.855 118.858C118.326 118.191 117.659 117.846 116.9 117.846C116.348 117.846 115.75 118.099 115.75 118.628C115.75 118.973 115.911 119.364 116.877 119.617L117.958 119.939C120.028 120.491 121.293 121.503 121.293 123.504Z",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132.5,
    y: 109.5,
    width: 71,
    height: 19,
    rx: 9.5,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.539 126.103C226.539 130.266 223.871 132.037 220.352 132.037C218.374 132.037 216.304 131.439 214.993 130.197L216.718 127.851C217.73 128.817 219.041 129.277 220.306 129.277C222.169 129.277 223.388 127.966 223.388 126.126V125.344C222.79 126.195 221.525 126.862 220.053 126.862C217.063 126.862 214.625 124.286 214.625 121.066C214.625 117.823 217.063 115.247 220.053 115.247C221.525 115.247 222.79 115.914 223.388 116.788V115.5H226.539V126.103ZM217.799 121.066C217.799 122.814 219.133 124.01 220.72 124.01C222.307 124.01 223.641 122.814 223.641 121.066C223.641 119.295 222.307 118.122 220.72 118.122C219.133 118.122 217.799 119.295 217.799 121.066ZM240.796 121.25C240.796 124.608 238.082 127.253 234.747 127.253C231.412 127.253 228.698 124.608 228.698 121.25C228.698 117.892 231.412 115.247 234.747 115.247C238.082 115.247 240.796 117.892 240.796 121.25ZM231.872 121.25C231.872 123.021 233.091 124.309 234.747 124.309C236.403 124.309 237.599 123.021 237.599 121.25C237.599 119.479 236.403 118.191 234.747 118.191C233.091 118.191 231.872 119.479 231.872 121.25ZM254.307 121.25C254.307 124.608 251.593 127.253 248.258 127.253C244.923 127.253 242.209 124.608 242.209 121.25C242.209 117.892 244.923 115.247 248.258 115.247C251.593 115.247 254.307 117.892 254.307 121.25ZM245.383 121.25C245.383 123.021 246.602 124.309 248.258 124.309C249.914 124.309 251.11 123.021 251.11 121.25C251.11 119.479 249.914 118.191 248.258 118.191C246.602 118.191 245.383 119.479 245.383 121.25ZM255.743 121.25C255.743 117.984 258.089 115.247 261.148 115.247C262.735 115.247 263.954 116.052 264.46 116.788V109.75H267.611V127H264.46V125.712C263.954 126.448 262.735 127.253 261.148 127.253C258.089 127.253 255.743 124.516 255.743 121.25ZM264.713 121.25C264.713 119.456 263.54 118.122 261.815 118.122C260.09 118.122 258.917 119.456 258.917 121.25C258.917 123.044 260.09 124.378 261.815 124.378C263.54 124.378 264.713 123.044 264.713 121.25Z",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.934 159L103.772 152.445L101.633 159H98.5049L94.6869 147.5H98.0449L100.23 154.86L102.553 147.5H104.968L107.314 154.86L109.476 147.5H112.857L109.062 159H105.934ZM117.973 143.613C117.973 144.717 117.076 145.614 115.949 145.614C114.868 145.614 113.948 144.717 113.948 143.613C113.948 142.509 114.868 141.612 115.949 141.612C117.076 141.612 117.973 142.509 117.973 143.613ZM114.385 159V147.5H117.536V159H114.385ZM128.029 158.885C127.523 159.046 126.902 159.138 126.028 159.138C123.59 159.138 121.635 157.781 121.635 154.975V150.26H119.312V147.5H121.635V144.303H124.786V147.5H128.029V150.26H124.786V154.354C124.786 155.757 125.384 156.309 126.741 156.309C127.247 156.309 127.661 156.24 128.029 156.102V158.885ZM130.178 159V141.75H133.329V148.811C133.927 147.891 135.123 147.247 136.618 147.247C139.401 147.247 141.057 149.271 141.057 152.261V159H137.906V152.79C137.906 151.134 137.193 150.122 135.882 150.122C134.433 150.122 133.329 151.18 133.329 153.388V159H130.178Z",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 148.5,
    y: 141.5,
    width: 113,
    height: 19,
    rx: 9.5,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.355 153.089V152.652C271.355 151.295 272.16 150.398 273.356 149.57C274.414 148.834 275.403 148.397 275.403 147.247C275.403 146.166 274.552 145.499 273.494 145.499C272.367 145.499 271.332 146.235 271.332 147.569H268.181C268.181 144.717 270.504 142.394 273.494 142.394C276.484 142.394 278.554 144.625 278.554 147.063C278.554 148.765 277.979 149.961 276.484 151.088C275.334 151.939 274.506 152.399 274.506 153.02V153.089H271.355ZM275.219 156.884C275.219 158.149 274.207 159.184 272.919 159.184C271.654 159.184 270.619 158.149 270.619 156.884C270.619 155.619 271.654 154.584 272.919 154.584C274.207 154.584 275.219 155.619 275.219 156.884Z",
    fill: "#212121"
  }))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-23-outside-1_14_178890",
    maskUnits: "userSpaceOnUse",
    x: 232.939,
    y: 169.388,
    width: 100.811,
    height: 100.81,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 232.939,
    y: 169.388,
    width: 100.811,
    height: 100.81
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.357 246.05C309.875 239.369 316.229 222.184 309.548 207.666C302.868 193.148 285.683 186.794 271.165 193.475C256.647 200.155 250.293 217.34 256.973 231.858C263.654 246.376 280.839 252.73 295.357 246.05Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M295.357 246.05C309.875 239.369 316.229 222.184 309.548 207.666C302.868 193.148 285.683 186.794 271.165 193.475C256.647 200.155 250.293 217.34 256.973 231.858C263.654 246.376 280.839 252.73 295.357 246.05Z",
    fill: "#E99ABB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M295.357 246.05C309.875 239.369 316.229 222.184 309.548 207.666C302.868 193.148 285.683 186.794 271.165 193.475C256.647 200.155 250.293 217.34 256.973 231.858C263.654 246.376 280.839 252.73 295.357 246.05Z",
    stroke: "#FFE8F1",
    strokeWidth: 18,
    mask: "url(#path-23-outside-1_14_178890)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M289.802 224.927C289.517 225.639 289.086 226.284 288.537 226.821C287.988 227.357 287.333 227.773 286.614 228.041C285.83 228.341 284.987 228.456 284.15 228.379C283.314 228.302 282.506 228.035 281.789 227.597",
    stroke: "#491249",
    strokeWidth: 1.57184,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M274.783 229.066C278.455 227.376 280.062 223.03 278.372 219.358C276.683 215.687 272.337 214.08 268.665 215.769C264.994 217.459 263.387 221.805 265.076 225.476C266.766 229.148 271.112 230.755 274.783 229.066Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M273.658 226.62C275.979 225.552 276.995 222.804 275.927 220.483C274.859 218.162 272.111 217.146 269.79 218.214C267.468 219.282 266.452 222.03 267.521 224.351C268.589 226.673 271.337 227.689 273.658 226.62Z",
    fill: "#491249"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M295.841 219.375C299.513 217.685 301.12 213.339 299.43 209.667C297.741 205.996 293.394 204.389 289.723 206.078C286.051 207.768 284.444 212.114 286.134 215.786C287.823 219.457 292.169 221.064 295.841 219.375Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M294.716 216.93C297.037 215.861 298.053 213.114 296.985 210.792C295.917 208.471 293.169 207.455 290.848 208.523C288.526 209.591 287.51 212.339 288.579 214.66C289.647 216.982 292.395 217.998 294.716 216.93Z",
    fill: "#491249"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M284.695 222.88C285.306 222.599 285.574 221.876 285.292 221.265C285.011 220.654 284.288 220.387 283.678 220.668C283.067 220.949 282.8 221.672 283.081 222.283C283.362 222.894 284.085 223.161 284.695 222.88Z",
    fill: "#491249"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M279.522 217.895C281.606 222.424 280.771 228.42 274.555 231.28C269.233 233.729 265.308 231.269 262.684 227.029C260 222.657 259.31 221.547 263.216 217.752C270.049 211.112 277.439 213.369 279.522 217.895Z",
    stroke: "#5E5E5E",
    strokeWidth: 1.86569,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M284.026 215.822C286.11 220.352 291.207 223.618 297.423 220.758C302.745 218.309 303.43 213.727 301.917 208.976C300.343 204.094 299.949 202.848 294.525 203.346C285.032 204.217 281.944 211.297 284.026 215.822Z",
    stroke: "#5E5E5E",
    strokeWidth: 1.86569,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M279.849 217.745L283.565 216.036",
    stroke: "#5E5E5E",
    strokeWidth: 1.86569,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M242.736 151.76C240.879 150.521 238.177 151.853 238.378 154.267L238.436 154.97C239.332 165.715 241.223 176.353 244.086 186.748C244.769 189.227 248.197 189.441 249.238 187.143L253.549 177.632C253.96 176.722 254.96 176.139 256.048 176.255L266.712 177.397C269.16 177.66 270.889 174.671 268.927 172.778C261.028 165.156 252.463 158.256 243.335 152.161L242.736 151.76Z",
    fill: "#E99ABB"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-34-outside-2_14_178890",
    maskUnits: "userSpaceOnUse",
    x: 29.9527,
    y: 185.477,
    width: 85.2055,
    height: 85.2056,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 29.9527,
    y: 185.477,
    width: 85.2055,
    height: 85.2056
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.0154 252.821C52.1777 248.897 44.1407 234.499 48.0643 220.661C51.9879 206.823 66.3862 198.786 80.2239 202.71C94.0616 206.633 102.099 221.032 98.175 234.869C94.2514 248.707 79.8531 256.744 66.0154 252.821Z"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M66.0154 252.821C52.1777 248.897 44.1407 234.499 48.0643 220.661C51.9879 206.823 66.3862 198.786 80.2239 202.71C94.0616 206.633 102.099 221.032 98.175 234.869C94.2514 248.707 79.8531 256.744 66.0154 252.821Z",
    fill: "#FFE051"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M66.0154 252.821C52.1777 248.897 44.1407 234.499 48.0643 220.661C51.9879 206.823 66.3862 198.786 80.2239 202.71C94.0616 206.633 102.099 221.032 98.175 234.869C94.2514 248.707 79.8531 256.744 66.0154 252.821Z",
    stroke: "#FFF9DE",
    strokeWidth: 16,
    mask: "url(#path-34-outside-2_14_178890)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M67.6978 231.961C67.9766 232.59 68.3828 233.154 68.8904 233.618C69.3979 234.081 69.9961 234.435 70.6471 234.656C71.3626 234.899 72.1238 234.975 72.8731 234.879C73.6223 234.783 74.3398 234.517 74.9711 234.102",
    stroke: "#491249",
    strokeWidth: 1.65337,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M61.8802 229.168C58.3806 228.176 56.348 224.534 57.3403 221.035C58.3326 217.535 61.9739 215.503 65.4735 216.495C68.9731 217.487 71.0057 221.128 70.0134 224.628C69.0211 228.128 65.3797 230.16 61.8802 229.168Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M62.5402 226.839C60.3276 226.211 59.0425 223.909 59.6699 221.696C60.2972 219.484 62.5995 218.199 64.8121 218.826C67.0247 219.453 68.3098 221.756 67.6824 223.968C67.055 226.181 64.7528 227.466 62.5402 226.839Z",
    fill: "#491249"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M72.2774 230.737C71.6952 230.572 71.3571 229.966 71.5222 229.384C71.6872 228.802 72.293 228.464 72.8751 228.629C73.4573 228.794 73.7954 229.4 73.6303 229.982C73.4653 230.564 72.8595 230.902 72.2774 230.737Z",
    fill: "#491249"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M78.1646 229.195C79.0127 228.35 80.0706 227.747 81.2294 227.446C82.3882 227.146 83.606 227.16 84.7577 227.486C86.3566 227.937 87.7316 228.964 88.6174 230.37",
    stroke: "#491249",
    strokeWidth: 1.65337,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M114.095 164.926C116.039 163.828 118.634 165.358 118.255 167.75L118.144 168.447C116.453 179.095 113.776 189.564 110.15 199.717C109.285 202.139 105.85 202.098 104.983 199.729L101.39 189.923C101.048 188.986 100.093 188.33 99.0003 188.365L88.2813 188.712C85.8203 188.792 84.3177 185.683 86.4152 183.941C94.858 176.927 103.912 170.682 113.468 165.282L114.095 164.926Z",
    fill: "#FFE051"
  })), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "path-41-outside-3_14_178890",
    maskUnits: "userSpaceOnUse",
    x: 66.3017,
    y: -2.35249,
    width: 69.9367,
    height: 69.9367,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 66.3017,
    y: -2.35249,
    width: 69.9367,
    height: 69.9367
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.321 53.2457C118.807 49.7306 125.268 37.57 121.753 26.0844C118.238 14.5987 106.077 8.13739 94.5915 11.6526C83.1059 15.1677 76.6445 27.3283 80.1597 38.8139C83.6749 50.2996 95.8354 56.7609 107.321 53.2457Z"
  }))), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M107.321 53.2457C118.807 49.7306 125.268 37.57 121.753 26.0844C118.238 14.5987 106.077 8.13739 94.5915 11.6526C83.1059 15.1677 76.6445 27.3283 80.1597 38.8139C83.6749 50.2996 95.8354 56.7609 107.321 53.2457Z",
    fill: "#FFAF4B"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M107.321 53.2457C118.807 49.7306 125.268 37.57 121.753 26.0844C118.238 14.5987 106.077 8.13739 94.5915 11.6526C83.1059 15.1677 76.6445 27.3283 80.1597 38.8139C83.6749 50.2996 95.8354 56.7609 107.321 53.2457Z",
    stroke: "#FFF1DF",
    strokeWidth: 12,
    mask: "url(#path-41-outside-3_14_178890)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M96.4791 29.7395C96.5439 29.3812 96.4911 29.0116 96.3288 28.6856C96.1384 28.3162 95.8231 28.0264 95.4388 27.868C95.0546 27.7096 94.6265 27.693 94.2311 27.8209L89.146 29.3772C88.7467 29.4925 88.4013 29.7459 88.1715 30.0922C87.9417 30.4385 87.8426 30.8552 87.8915 31.2679C87.9389 31.6294 88.1037 31.9653 88.3604 32.2242C88.5306 32.3989 88.6566 32.6117 88.7279 32.8449C88.7993 33.0782 88.814 33.325 88.7707 33.5651C88.7034 33.9233 88.7548 34.2938 88.9175 34.62C89.1084 34.9886 89.4239 35.2775 89.8078 35.4352C90.1918 35.593 90.6193 35.6094 91.0142 35.4814L96.0993 33.9251C96.4982 33.8101 96.8433 33.5573 97.0732 33.2117C97.3031 32.8661 97.4028 32.4501 97.3547 32.0378C97.3064 31.677 97.1433 31.3413 96.8895 31.0803C96.7178 30.9066 96.5908 30.6939 96.5193 30.4604C96.4479 30.2269 96.4341 29.9795 96.4791 29.7395Z",
    fill: "#491249"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M111.269 25.213C111.333 24.8547 111.281 24.4853 111.122 24.1582C110.931 23.7888 110.616 23.499 110.232 23.3406C109.847 23.1822 109.419 23.1655 109.024 23.2935L103.936 24.8508C103.536 24.9661 103.191 25.2194 102.961 25.5658C102.731 25.9121 102.632 26.3287 102.681 26.7414C102.73 27.1024 102.895 27.4378 103.15 27.6978C103.32 27.8725 103.446 28.0853 103.517 28.3185C103.589 28.5517 103.604 28.7986 103.56 29.0386C103.495 29.3969 103.546 29.7668 103.707 30.0935C103.898 30.4621 104.213 30.7511 104.597 30.9088C104.981 31.0665 105.409 31.0829 105.804 30.955L110.886 29.3997C111.284 29.2847 111.63 29.0319 111.859 28.6863C112.089 28.3406 112.189 27.9246 112.141 27.5123C112.09 27.152 111.926 26.8172 111.672 26.556C111.501 26.3814 111.376 26.168 111.305 25.9341C111.235 25.7003 111.222 25.4528 111.269 25.213Z",
    fill: "#491249"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M103.098 39.4698L102.682 39.5971C100.308 40.2247 97.8648 40.0044 96.1787 38.999C95.9806 38.8812 95.8078 38.7254 95.67 38.5406C95.5322 38.3559 95.4319 38.1457 95.3755 37.9222C95.319 37.6988 95.3074 37.4663 95.3409 37.2383C95.3743 37.0102 95.4522 36.791 95.5705 36.5932C95.8088 36.1942 96.1957 35.9062 96.6462 35.7924C97.0967 35.6786 97.5741 35.7483 97.9732 35.9862C98.6322 36.3784 100.016 36.6733 101.787 36.2049C103.69 35.7031 104.846 34.6416 105.105 33.8695C105.181 33.6518 105.299 33.4511 105.452 33.2791C105.606 33.1071 105.792 32.9671 106 32.8671C106.207 32.767 106.433 32.7089 106.663 32.6962C106.894 32.6834 107.124 32.7162 107.342 32.7927C107.559 32.8686 107.76 32.9867 107.932 33.1403C108.104 33.2938 108.244 33.4799 108.344 33.6877C108.444 33.8955 108.502 34.1209 108.515 34.3512C108.528 34.5814 108.495 34.8118 108.418 35.0294C107.736 36.9908 105.712 38.6696 103.098 39.4698Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M92.0112 30.5342L91.8167 30.5937C91.7006 30.6283 91.5755 30.6155 91.4687 30.5583C91.3618 30.501 91.2818 30.404 91.2463 30.2881L91.1868 30.0936C91.1512 29.9772 91.071 29.8795 90.9635 29.8224C90.8559 29.7653 90.7299 29.7532 90.6134 29.7888C90.497 29.8245 90.3993 29.905 90.3421 30.0126C90.285 30.1201 90.2732 30.2459 90.3089 30.3623L90.3684 30.5568C90.4038 30.6727 90.3918 30.7979 90.3353 30.9051C90.2789 31.0124 90.1823 31.0929 90.0667 31.1293L89.8723 31.1888C89.7564 31.2243 89.6592 31.3041 89.6019 31.4109C89.5446 31.5177 89.5321 31.6428 89.5666 31.7589C89.6023 31.8754 89.6828 31.9729 89.7903 32.0301C89.8979 32.0872 90.0236 32.0994 90.14 32.0637L90.3345 32.0042C90.392 31.9866 90.4525 31.9805 90.5123 31.9864C90.5722 31.9923 90.6302 32.0099 90.6833 32.0384C90.7363 32.0668 90.7831 32.1054 90.8211 32.152C90.8591 32.1986 90.8878 32.2523 90.9049 32.3099L90.9644 32.5043C91.0008 32.6199 91.0812 32.7165 91.1884 32.773C91.2956 32.8294 91.4209 32.8412 91.5368 32.8057C91.6526 32.7703 91.7498 32.6904 91.8071 32.5836C91.8644 32.4768 91.877 32.3517 91.8424 32.2356L91.7829 32.0412C91.7648 31.9839 91.7585 31.9234 91.7639 31.8635C91.7693 31.8036 91.7866 31.7453 91.8146 31.6921C91.8426 31.6389 91.8808 31.5918 91.9272 31.5534C91.9735 31.515 92.027 31.4862 92.0845 31.4686L92.279 31.4091C92.3954 31.3735 92.4928 31.293 92.5499 31.1855C92.6071 31.0779 92.6192 30.9521 92.5836 30.8356C92.5472 30.72 92.4665 30.6235 92.3592 30.567C92.252 30.5106 92.1271 30.4987 92.0112 30.5342Z",
    fill: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M95.115 31.9658L94.9876 32.0048C94.9121 32.0279 94.8302 32.0202 94.7605 31.9831C94.6907 31.946 94.6384 31.8827 94.6153 31.8071L94.5773 31.6831C94.5542 31.6075 94.5023 31.5441 94.4325 31.507C94.3627 31.47 94.2809 31.4622 94.2054 31.4854C94.1298 31.5085 94.0666 31.5606 94.0296 31.6304C93.9925 31.7002 93.9846 31.7818 94.0077 31.8574L94.0457 31.9815C94.0688 32.057 94.061 32.1387 94.0239 32.2085C93.9868 32.2783 93.9233 32.3305 93.8478 32.3536L93.7237 32.3916C93.6481 32.4147 93.585 32.4669 93.5479 32.5367C93.5109 32.6065 93.503 32.6881 93.5261 32.7637C93.5492 32.8393 93.6015 32.9026 93.6713 32.9396C93.7411 32.9767 93.8226 32.9846 93.8981 32.9615L94.0222 32.9235C94.0978 32.9004 94.1796 32.9081 94.2494 32.9452C94.3192 32.9823 94.3714 33.0456 94.3945 33.1212L94.4335 33.2486C94.4566 33.3241 94.5088 33.3874 94.5786 33.4244C94.6484 33.4615 94.7299 33.4694 94.8055 33.4463C94.8811 33.4232 94.9445 33.3709 94.9816 33.3011C95.0187 33.2313 95.0262 33.1498 95.0031 33.0743L94.9641 32.9468C94.941 32.8713 94.9488 32.7896 94.9859 32.7198C95.023 32.65 95.0865 32.5978 95.1621 32.5747L95.2894 32.5357C95.365 32.5126 95.4281 32.4604 95.4652 32.3906C95.5023 32.3208 95.5101 32.2392 95.487 32.1636C95.4639 32.088 95.4116 32.0247 95.3418 31.9876C95.2721 31.9506 95.1905 31.9427 95.115 31.9658Z",
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M106.968 25.9573L106.774 26.0168C106.658 26.0513 106.533 26.0385 106.426 25.9812C106.319 25.924 106.239 25.8269 106.204 25.711L106.144 25.5166C106.109 25.4001 106.028 25.3026 105.921 25.2455C105.813 25.1883 105.687 25.1762 105.571 25.2118C105.455 25.2482 105.359 25.3287 105.302 25.436C105.246 25.5432 105.234 25.6684 105.27 25.7843L105.329 25.9787C105.365 26.0952 105.353 26.2211 105.296 26.3286C105.238 26.4362 105.141 26.5166 105.024 26.5523L104.83 26.6118C104.714 26.6472 104.617 26.7271 104.559 26.8339C104.502 26.9407 104.49 27.0658 104.524 27.1819C104.56 27.2984 104.64 27.3959 104.748 27.453C104.855 27.5102 104.981 27.5224 105.098 27.4867L105.292 27.4272C105.408 27.3916 105.534 27.4035 105.642 27.4607C105.75 27.5178 105.83 27.6154 105.866 27.7319L105.925 27.9263C105.961 28.0418 106.04 28.1387 106.147 28.1954C106.254 28.2521 106.379 28.2641 106.494 28.2287C106.61 28.1932 106.707 28.1134 106.765 28.0066C106.822 27.8998 106.834 27.7747 106.8 27.6586L106.74 27.4642C106.722 27.4068 106.716 27.3463 106.721 27.2864C106.727 27.2265 106.744 27.1683 106.772 27.1151C106.8 27.0619 106.838 27.0147 106.885 26.9764C106.931 26.938 106.984 26.9093 107.042 26.8917L107.236 26.8322C107.353 26.7966 107.45 26.716 107.507 26.6085C107.565 26.5009 107.577 26.3751 107.541 26.2586C107.523 26.2011 107.495 26.1476 107.456 26.1013C107.418 26.055 107.371 26.0167 107.317 25.9887C107.264 25.9607 107.206 25.9435 107.146 25.9381C107.086 25.9327 107.026 25.9392 106.968 25.9573Z",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M110.086 27.385L109.962 27.4229C109.925 27.4344 109.885 27.4384 109.846 27.4346C109.807 27.4309 109.769 27.4196 109.735 27.4013C109.7 27.3829 109.67 27.3578 109.645 27.3276C109.62 27.2974 109.602 27.2626 109.59 27.2252L109.552 27.1012C109.529 27.0256 109.477 26.9623 109.407 26.9252C109.337 26.8881 109.255 26.8804 109.18 26.9035C109.104 26.9267 109.041 26.9788 109.004 27.0485C108.967 27.1183 108.959 27.2 108.982 27.2756L109.02 27.3997C109.043 27.4752 109.035 27.5569 108.998 27.6267C108.961 27.6965 108.898 27.7487 108.822 27.7718L108.695 27.8108C108.619 27.8339 108.556 27.8861 108.519 27.9559C108.482 28.0256 108.474 28.1073 108.497 28.1829C108.52 28.2585 108.573 28.3218 108.642 28.3588C108.712 28.3959 108.794 28.4038 108.869 28.3807L108.997 28.3417C109.072 28.3186 109.154 28.3263 109.224 28.3634C109.294 28.4005 109.346 28.4638 109.369 28.5393L109.408 28.6668C109.431 28.7423 109.483 28.8055 109.553 28.8426C109.623 28.8797 109.704 28.8876 109.78 28.8645C109.856 28.8414 109.919 28.7891 109.956 28.7193C109.993 28.6495 110.001 28.5679 109.978 28.4923L109.939 28.3649C109.927 28.3275 109.923 28.2882 109.927 28.2493C109.931 28.2103 109.942 28.1725 109.96 28.138C109.979 28.1034 110.004 28.0728 110.034 28.0479C110.064 28.023 110.099 28.0043 110.137 27.9929L110.261 27.9549C110.336 27.9318 110.399 27.8796 110.436 27.8098C110.473 27.74 110.481 27.6583 110.458 27.5828C110.435 27.5072 110.383 27.4439 110.313 27.4068C110.243 27.3698 110.162 27.3618 110.086 27.385Z",
    fill: "white"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M157.348 67.0958C158.284 68.8453 156.873 71.1205 154.755 70.7354L154.138 70.623C144.709 68.9057 135.46 66.3167 126.51 62.8892C124.376 62.0721 124.481 59.0206 126.604 58.2976L135.39 55.3021C136.23 55.0167 136.832 54.1818 136.823 53.2098L136.731 43.6773C136.708 41.4886 139.502 40.2159 141.008 42.1149C147.071 49.759 152.438 57.9303 157.045 66.531L157.348 67.0958Z",
    fill: "#FFAF4B"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_14_178890",
    x: 43.7949,
    y: -14.5184,
    width: 188.772,
    height: 188.772,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 25.8592,
    result: "effect1_foregroundBlur_14_178890"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_14_178890",
    x: 117.475,
    y: -14.5184,
    width: 188.772,
    height: 188.772,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 25.8592,
    result: "effect1_foregroundBlur_14_178890"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_14_178890",
    x: 46.3618,
    y: 34.6141,
    width: 188.772,
    height: 188.772,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 25.8592,
    result: "effect1_foregroundBlur_14_178890"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_14_178890",
    x: 93.7705,
    y: 34.6141,
    width: 188.772,
    height: 188.772,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 25.8592,
    result: "effect1_foregroundBlur_14_178890"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_14_178890",
    x: 141.179,
    y: 34.6141,
    width: 188.772,
    height: 188.772,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 25.8592,
    result: "effect1_foregroundBlur_14_178890"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_f_14_178890",
    x: 70.0659,
    y: 83.7465,
    width: 188.772,
    height: 188.772,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 25.8592,
    result: "effect1_foregroundBlur_14_178890"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_f_14_178890",
    x: 117.475,
    y: 83.7465,
    width: 188.772,
    height: 188.772,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 25.8592,
    result: "effect1_foregroundBlur_14_178890"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_d_14_178890",
    x: 26.1499,
    y: 64.9,
    width: 321.7,
    height: 189.4,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 13.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_14_178890"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_14_178890",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_d_14_178890",
    x: 14.5,
    y: 15,
    width: 345,
    height: 226,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_14_178890"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_14_178890",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14_178890"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 375,
    height: 264,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome2);
export default __webpack_public_path__ + "static/media/home2.72a8b54b3b480c91e75a486f3c2b064e.svg";
export { ForwardRef as ReactComponent };